<template>
  <div class="app-main-inner app-main-page push-config">
    <div class="app-main-inner-row">
      <div class="filters">
        <el-form :inline="true" label-width="100px" label-position="right">
          <div class="el-form-item-wrapper">
            <el-form-item label-width="50px" :label="$t('SystemMaintenance.Branch')">
              <el-select v-model="branchId" @change="getCustomerNotificationConfig">
                <el-option
                  v-for="office in currentOfficeList"
                  :key="office.uuid"
                  :value="office.officeId"
                  :label="office.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="branchId!==1" :label="$t('SystemMaintenance.ApplyTheHeadOfficesSettings')">
              <el-checkbox v-model="customerNotifConfigForm.userHeadQuarters" @change="applyHeadOfficeConfig" />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="triggers">
        <!--        fixme: 待确认，该权限符不存在于数据库 -->
        <!--        v-permission="['role_pushConfig_saveButton']"  -->
        <el-button type="primary" style="margin-left: 30px;" @click="saveConfig">
          {{ $t('common.btn.save') }}
        </el-button>
      </div>
    </div>
    <div class="app-main-inner-row">
      <el-form :disabled="customerNotifConfigForm.userHeadQuarters" label-width="600px" label-position="left">
        <el-row style="width:500px">
          <el-col :span="6">{{ $t('SystemMaintenance.NotificationObject') }}</el-col>
          <el-col :span="6">
            <el-checkbox v-model="customerNotifConfigForm.sales">{{ $t('SystemMaintenance.Sales') }}</el-checkbox>
          </el-col>
          <el-col :span="6">
            <el-checkbox v-model="customerNotifConfigForm.salesExcutive">{{ $t('SystemMaintenance.Supervisor') }}</el-checkbox>
          </el-col>
          <el-col :span="6" />
        </el-row>
        <el-row style="width:500px">
          <el-col :span="6">{{ $t('SystemMaintenance.NotificationMethod') }}</el-col>
          <el-col :span="6">
            <el-checkbox v-model="customerNotifConfigForm.internaleReminder">{{ $t('SystemMaintenance.InternalReminder') }}</el-checkbox>
          </el-col>
          <el-col :span="6">
            <el-checkbox v-model="customerNotifConfigForm.email">{{ $t('SystemMaintenance.Email') }}</el-checkbox>
          </el-col>
          <el-col :span="6" />
        </el-row>
        <el-row style="width:500px">
          <el-col :span="6">{{ $t('SystemMaintenance.HowDaysBeforeExpirationNotice') }}</el-col>
          <el-col :span="6">
            <el-checkbox v-model="customerNotifConfigForm.dueDays1Flag" />
            <el-input v-model="customerNotifConfigForm.dueDays1" style="padding-right:3px;padding-left:3px;width:50px" maxlength="2" onkeyup="value=value.replace(/[^\d]/g,'')" onblur="if(value === '0' || value === '00'){value = ''}" />{{ $t('SystemMaintenance.Days') }}</el-col>
          <el-col :span="6">
            <el-checkbox v-model="customerNotifConfigForm.dueDays2Flag" />
            <el-input v-model="customerNotifConfigForm.dueDays2" style="padding-right:3px;padding-left:3px;width:50px" maxlength="2" onkeyup="value=value.replace(/[^\d]/g,'')" onblur="if(value === '0' || value === '00'){value = ''}" />{{ $t('SystemMaintenance.Days') }}</el-col>
          <el-col :span="6">
            <el-checkbox v-model="customerNotifConfigForm.dueDays3Flag" />
            <el-input v-model="customerNotifConfigForm.dueDays3" style="padding-right:3px;padding-left:3px;width:50px" maxlength="2" onkeyup="value=value.replace(/[^\d]/g,'')" onblur="if(value === '0' || value === '00'){value = ''}" />{{ $t('SystemMaintenance.Days') }}</el-col>
        </el-row>
        <el-row style="width:500px">
          <el-col :span="6">{{ $t('SystemMaintenance.DayMaintenance') }}</el-col>
          <el-col :span="9">
            <el-form-item :label="$t('SystemMaintenance.SleepingDays')" label-width="60px">
              <el-input v-model="customerNotifConfigForm.sleepingDays" style="width:60px" maxlength="4" oninput="value=value.replace(/[^\d]/g,'')">{{ $t('SystemMaintenance.Days') }}</el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item :label="$t('SystemMaintenance.SigningDays')" label-width="60px">
              <el-input v-model="customerNotifConfigForm.signingDays" style="width:60px" maxlength="4" oninput="value=value.replace(/[^\d]/g,'')">{{ $t('SystemMaintenance.Days') }}</el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { getUserInfo } from '@/utils/auth'
import {
  getCustomerNotificationConfig, saveCustomerNotificationConfig
} from '@/api/sysManage/baseConfig/customerNotificationConfig'

export default {
  name: 'CustomerNotificationConfiguration',
  data() {
    return {
      loading: false,
      branchId: 0,
      initcustomerNotifConfigForm: {
        branchId: 0,
        userHeadQuarters: false,
        sales: false,
        salesExcutive: false,
        internaleReminder: false,
        email: false,
        dueDays1: 30,
        dueDays2: '',
        dueDays3: '',
        dueDays1Flag: true,
        dueDays2Flag: false,
        dueDays3Flag: false,
        sleepingDays: 360,
        signingDays: 180
      },
      customerNotifConfigForm: {},
      originCustomerNotifConfig: {}
    }
  },
  computed: {
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    }
  },
  mounted() {
    this.branchId = this.currentOfficeList[0].officeId
    this.getCustomerNotificationConfig(this.branchId)
  },
  methods: {
    getCustomerNotificationConfig(value) {
      const self = this
      this.loading = getLoading()
      getCustomerNotificationConfig(value).then(result => {
        self.customerNotifConfigForm = result.data ? result.data : this.initcustomerNotifConfigForm
        self.customerNotifConfigForm.dueDays1 = self.customerNotifConfigForm.dueDays1 === 0 ? '' : self.customerNotifConfigForm.dueDays1
        self.customerNotifConfigForm.dueDays2 = self.customerNotifConfigForm.dueDays2 === 0 ? '' : self.customerNotifConfigForm.dueDays2
        self.customerNotifConfigForm.dueDays3 = self.customerNotifConfigForm.dueDays3 === 0 ? '' : self.customerNotifConfigForm.dueDays3
        self.originCustomerNotifConfig = { ...self.customerNotifConfigForm }
      }).finally(
        self.loading.close()
      )
    },
    saveConfig: async function() {
      const self = this
      let customerNotification = {}
      await this.checkForm()

      customerNotification = {
        uuid: this.customerNotifConfigForm.uuid,
        sales: this.customerNotifConfigForm.sales,
        salesExcutive: this.customerNotifConfigForm.salesExcutive,
        internaleReminder: this.customerNotifConfigForm.internaleReminder,
        email: this.customerNotifConfigForm.email,
        dueDays1: this.customerNotifConfigForm.dueDays1,
        dueDays2: this.customerNotifConfigForm.dueDays2,
        dueDays3: this.customerNotifConfigForm.dueDays3,
        dueDays1Flag: this.customerNotifConfigForm.dueDays1Flag,
        dueDays2Flag: this.customerNotifConfigForm.dueDays2Flag,
        dueDays3Flag: this.customerNotifConfigForm.dueDays3Flag,
        sleepingDays: this.customerNotifConfigForm.sleepingDays,
        signingDays: this.customerNotifConfigForm.signingDays,
        userHeadQuarters: this.customerNotifConfigForm.userHeadQuarters,
        version: this.customerNotifConfigForm.version,
        branchId: this.branchId
      }
      this.loading = getLoading()
      saveCustomerNotificationConfig(customerNotification).then(() => {
        self.customerNotifConfigForm = { ...self.customerNotifConfigForm }
        self.$message.success(self.$t('common.tips.saveSuccess'))
        self.getCustomerNotificationConfig(self.branchId)
      }).finally(
        self.loading.close()
      )
    },
    applyHeadOfficeConfig(value) {
      const target = value
      if (value) {
        this.customerNotifConfigForm.userHeadQuarters = target
      }
    },
    // onInput0_100(e) {
    //   this.$message.closeAll();
    //   if (e.target.value < 0 || e.target.value > 100) {
    //     this.$message.warning("只能输入[0,100]区间的数");
    //   }
    //   e.target.value = (e.target.value >= 0 && e.target.value <= 100 && e.target.value.match(/^\d{1,3}(\.\d*)?$/)[0]) || null;
    // },
    // 提交验证
    async checkForm() {

    }
  }
}
</script>

<style scoped>
.push-config fieldset {
  background: #fff;
  border: #e6ebf5 solid 2px;
  border-radius: 5px;
  padding: 10px 30px;
}
.push-config fieldset legend {
  font-size: 14px;
  padding-top: 5px;
}
</style>
